import { ReportsTranslate } from './reportsTranslate.model';

const reportsTranslatePTBR: ReportsTranslate = {
  page: {
    title: 'Relatórios e exportações',
    subtitle:
      'Baixe planilhas CSV com seus dados ou um relatório mensal em PDF.',
  },
  csvSection: {
    title: 'Exportar CSV',
    availability: 'Disponível nos planos Studio e Coletivo',
    planLockedAlert: 'Seu plano atual não inclui exportação CSV. Faça upgrade.',
    leadsButton: 'Leads (CSV)',
    eventsButton: 'Eventos (CSV)',
    downloading: 'Baixando…',
  },
  pdfSection: {
    title: 'Relatório mensal em PDF',
    availability: 'Disponível no plano Coletivo',
    monthPlaceholder: 'Mês',
    yearPlaceholder: 'Ano',
    planLockedAlert: 'Seu plano atual não inclui relatórios em PDF.',
    downloadButton: 'Baixar PDF',
    generating: 'Gerando PDF…',
  },
  months: {
    january: 'Janeiro',
    february: 'Fevereiro',
    march: 'Março',
    april: 'Abril',
    may: 'Maio',
    june: 'Junho',
    july: 'Julho',
    august: 'Agosto',
    september: 'Setembro',
    october: 'Outubro',
    november: 'Novembro',
    december: 'Dezembro',
  },
};

export default reportsTranslatePTBR;
